import { Services } from '@ekhodealer/ekho-common';
import { Callout } from '@ekhodealer/ekho-common/rev';

import { TablePageLayout } from '@common/components/TablePageLayout';
import { useCurrentServicesProvider } from '@common/hooks/useCurrentServicesProvider';
import { FiltersDrawer } from '@features/inventory/components/filters/FiltersDrawer';
import { InventoryDrawer } from '@features/inventory/components/InventoryDrawer';
import { InventoryTable } from '@features/inventory/components/InventoryTable';
import { InventoryToolbar } from '@features/inventory/components/InventoryToolbar';

export default function InventoryPage() {
	const { data: servicesProvider } = useCurrentServicesProvider();

	const hasDmsConnection = !!servicesProvider?.config?.[Services.INVENTORY]?.dmsConnectionConfig;

	return (
		<>
			<TablePageLayout
				title='Inventory'
				aboveTableContent={hasDmsConnection ? <InventoryToolbar /> : undefined}
				tableContent={
					hasDmsConnection ? (
						<InventoryTable />
					) : (
						<Callout title='No DMS connection configured' variant='error'>
							There is no DMS connection configured for this services provider.
						</Callout>
					)
				}
			/>
			{hasDmsConnection && (
				<>
					<InventoryDrawer />
					<FiltersDrawer />
				</>
			)}
		</>
	);
}
